module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'search-bar': true,
      fixed: _vm.fixed,
        puppet: _vm.puppet
    }
  }, [_c('div', {
    staticClass: "search-wrap"
  }, [_c('div', {
    staticClass: "search-bar-contrainer"
  }, [_c('div', {
    staticClass: "search-bar-input"
  }, [_c('i', {
    staticClass: "yxl-font yxl-font-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    ref: "search-input",
    attrs: {
      "type": "search",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enter($event)
      },
      "change": _vm.change,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-touch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.inputValue),
      expression: "!!inputValue"
    }],
    staticClass: "yxl-font yxl-font-FM51delete2 clear-btn",
    attrs: {
      "tag": "i"
    },
    on: {
      "tap": function($event) {
        _vm.inputValue = ''
      }
    }
  })], 1)]), _vm._v(" "), (_vm.isShowButton) ? _c('v-touch', {
    staticClass: "search-btn",
    on: {
      "tap": _vm.enter
    }
  }, [_vm._v("\n      " + _vm._s(_vm.btnText) + "\n    ")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e8df334!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/searchBar.vue
// module id = 2453
// module chunks = 115